import * as Yup from "yup";
import baseSchema from "./BaseValidation";

const Language = require("sccLanguage").default;

const schema = Yup.object({
  textMessage: baseSchema(Language).notRequiredStringMinMaxEmptyString,
});

export default schema;
